.stars {
  display: flex;
  gap: 8px;
  margin-top: 16px;
}

.centered .stars {
  justify-content: center;
}

.legend {
  width: 100%;
}

.star {
  cursor: pointer;
}

.stars .starEmpty path {
  fill: var(--star-rating-empty-color, var(--colors-grays-light));
}

.stars .starFilled path {
  fill: var(--star-rating-fill-color, var(--colors-brand-gold-main));
}

.input {
  clip-path: inset(50%);
  height: 1px;
  overflow: hidden;
  position: absolute;
  width: 1px;
}

.input:focus-visible + * {
  outline: 2px solid var(--colors-primary-main);
  outline-offset: 2px;
}
